// src/theme/theme.js
import { DefaultTheme } from 'react-native-paper';

export const AVAQualisTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    // Cores personalizadas
    primary: '#A4C639',           // Verde AVAQualis
    primaryDark: '#8DB32A',       // Verde mais escuro
    secondary: '#4A4A4A',         // Cinza escuro
    tertiary: '#AAAAAA',          // Cinza claro
    background: '#FFFFFF',        // Branco
    surface: '#F8F9FA',           // Cinza muito claro para cards
    surfaceVariant: '#F1F3F4',    // Variação de surface
    onPrimary: '#FFFFFF',         // Texto sobre cor primária
    onSecondary: '#FFFFFF',       // Texto sobre cor secundária
    onBackground: '#4A4A4A',      // Texto sobre fundo
    onSurface: '#4A4A4A',         // Texto sobre surface
    outline: '#E0E0E0',           // Bordas
    success: '#4CAF50',           // Verde sucesso
    warning: '#FF9800',           // Laranja aviso
    error: '#F44336',             // Vermelho erro
    info: '#2196F3',              // Azul informação
    
    // Níveis de elevação obrigatórios para o react-native-paper
    elevation: {
      level0: 'transparent',
      level1: 'rgb(250, 250, 250)',
      level2: 'rgb(245, 245, 245)',
      level3: '#E0E0E0',          // Esta é a que estava causando o erro
      level4: 'rgb(235, 235, 235)',
      level5: 'rgb(230, 230, 230)',
    }
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
  },
  borderRadius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    full: 9999,
  },
  shadows: {
    small: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 2,
    },
    medium: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.15,
      shadowRadius: 8,
      elevation: 4,
    },
    large: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.2,
      shadowRadius: 16,
      elevation: 8,
    },
  },
  typography: {
    h1: {
      fontSize: 32,
      fontWeight: 'bold',
      color: '#4A4A4A',
    },
    h2: {
      fontSize: 24,
      fontWeight: 'bold',
      color: '#4A4A4A',
    },
    h3: {
      fontSize: 20,
      fontWeight: '600',
      color: '#4A4A4A',
    },
    body: {
      fontSize: 16,
      fontWeight: 'normal',
      color: '#4A4A4A',
    },
    caption: {
      fontSize: 12,
      fontWeight: 'normal',
      color: '#AAAAAA',
    },
  },
  // Configurações específicas para componentes
  roundness: 8, // Border radius padrão para componentes
  animation: {
    scale: 1.0,
  },
};

// Configuração do React Native Paper com as cores do AVAQualis
export const paperTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#A4C639',
    accent: '#8DB32A',
    background: '#FFFFFF',
    surface: '#F8F9FA',
    text: '#4A4A4A',
    disabled: '#AAAAAA',
    placeholder: '#AAAAAA',
    backdrop: 'rgba(0, 0, 0, 0.5)',
    notification: '#A4C639',
    // Garantir que os níveis de elevação estejam presentes
    elevation: {
      ...DefaultTheme.colors.elevation,
      level3: '#E0E0E0'
    }
  },
  roundness: 8,
};

// Exportando também como default para compatibilidade
export default AVAQualisTheme;